import React, { Component } from 'react';

export default class Modal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: this.props.modal && this.props.modal.name ? this.props.modal.name : ''
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState(state => {
			state.name = nextProps.modal && nextProps.modal.name ? nextProps.modal.name : '';
			return state;
		});
	}

	render() {
		return (
			<div className="MODAL">
				<div className="text">Are you sure you want to delete <b>{this.state.name}</b>?</div>
				<button className="button alt-confirm" onClick={() => (
					this.props.handleEditSet('DELETE', {
						setId: this.props.selectedSet
					})
				)}>Delete</button>
				<label htmlFor="modal-toggle" className="button alt-cancel">Cancel</label>
			</div>
		);
	}
};


// WEBPACK FOOTER //
// ./src/modals/delete-set.js